import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { TenantStatusEnum } from '../enums/tenant-status.enum';

/**
 * Tenants filters
 */
export class TenantsFilters extends ApiRequestFilters {
	/**
	 * Countries id values
	 */
	countries?: number[];

	/**
	 * Status values
	 */
	statuses?: TenantStatusEnum[];

	/**
	 * Exact match on tenant_billing.meteringProviderCustomerId
	 */
	meteringProviderCustomerId?: string;
}
